/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreVCard = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M7.166 7.192a.595.595 0 0 0 .081-.297v-.956c0-.526-.675-.953-1.254-.953s-1.256.427-1.256.953l.001.956a.6.6 0 0 0 .082.297l.62 1.061a.744.744 0 0 0 1.107 0l.619-1.061zM13.5 9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm0-2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm0-2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-4 5.5a.5.5 0 0 1-.5.5h-.5v-.131c0-.37-.126-.729-.353-1.013L7.6 9.175a.502.502 0 0 0-.39-.187H4.774a.498.498 0 0 0-.398.199l-.567.748c-.21.277-.325.625-.325.977V11H3a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 3 4h6a.5.5 0 0 1 .5.5v6zm6 3v-9C15.5 3.121 14.378 2 13 2H3A2.503 2.503 0 0 0 .5 4.5v9a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5z"
    />
  </svg>
);

IconCoreVCard.displayName = 'IconCoreVCard';

IconCoreVCard.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreVCard);
IconCoreVCard.displayName = 'IconCoreVCard';
